import { createAction, props } from '@ngrx/store';

export const getUsers = createAction('[USERS] get users');
export const getUsersSuccess = createAction('[USERS] get users success', props<{ users: any }>());
export const updateUserSuccess = createAction('[USERS] update users success', props<{ users: any }>());
